var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"yj-form",class:[
  _vm.labelPosition ? 'yj-form--label-' + _vm.labelPosition : '',
  { 'yj-form--inline': _vm.inline }
]},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/form/src/form.vue